import { CashFund, Check, CreditCard, CreditPayment, Employee, Expense, ExpenseType, PaymentOrder, PaymentType, Settings, Tax, Transaction, Ticket, AdjustmentNote } from "./types"
import { FiscalDocument } from "../../fiscal-documents"

export enum ActionType {
    SET_CURRENT_EMPLOYEE = 'setCurrentEmployee',
    SET_TAXES = 'setTaxes',
    UPDATE_TAXES = 'updateTaxes',
    REMOVE_TAXES = 'removeTaxes',
    SET_SETTINGS = 'setSettings',
    UPDATE_SETTINGS = 'updateSettings',
    SET_CASH_FUNDS = 'setCashFunds',
    UPDATE_CASH_FUNDS = 'updateCashFunds',
    REMOVE_CASH_FUNDS = 'removeCashFunds',
    UPDATE_CHECKS = 'updateChecks',
    REMOVE_CHECKS = 'removeChecks',
    SET_CREDIT_CARDS = 'setCreditCards',
    UPDATE_CREDIT_CARDS = 'updateCreditCards',
    REMOVE_CREDIT_CARDS = 'removeCreditCards',
    UPDATE_CREDIT_PAYMENTS = 'updateCreditPayments',
    REMOVE_CREDIT_PAYMENTS = 'removeCreditPayments',
    UPDATE_FISCAL_DOCUMENTS = 'updateFiscalDocuments',
    REMOVE_FISCAL_DOCUMENTS = 'removeFiscalDocuments',
    UPDATE_TRANSACTIONS = 'updateTransactions',
    REMOVE_TRANSACTIONS = 'removeTransactions',
    SET_PAYMENT_TYPES = 'setPaymentTypes',
    UPDATE_PAYMENT_TYPES = 'updatePaymentTypes',
    REMOVE_PAYMENT_TYPES = 'removePaymentTypes',
    SET_EMPLOYEES = 'setEmployees',
    UPDATE_EMPLOYEES = 'updateEmployees',
    REMOVE_EMPLOYEES = 'removeEmployees',
    SET_EXPENSE_TYPES = 'setExpenseTypes',
    UPDATE_EXPENSE_TYPES = 'updateExpenseTypes',
    REMOVE_EXPENSE_TYPES = 'removeExpenseTypes',
    UPDATE_EXPENSES = 'updateExpenses',
    REMOVE_EXPENSES = 'removeExpenses',
    UPDATE_PAYMENT_ORDERS = 'updatePaymentOrders',
    REMOVE_PAYMENT_ORDERS = 'removePaymentOrders',
    UPDATE_ADJUSTMENT_NOTES = 'updateAdjustmentNotes',
    REMOVE_ADJUSTMENT_NOTES = 'removeAdjustmentNotes',
    UPDATE_TICKETS = 'updateTickets',
    REMOVE_TICKETS = 'removeTickets',
    SELECT_TICKETS = 'selectTickets'
}

interface SetCurrentEmployee {
    type: ActionType.SET_CURRENT_EMPLOYEE
    payload: Employee
}
interface SetTaxes {
    type: ActionType.SET_TAXES
    payload: Tax[]
}

interface UpdateTaxes {
    type: ActionType.UPDATE_TAXES
    payload: Tax[]
}

interface RemoveTaxes {
    type: ActionType.REMOVE_TAXES
    payload: string[]
}

interface SetSettings {
    type: ActionType.SET_SETTINGS
    payload: Settings[]
}

interface UpdateSettings {
    type: ActionType.UPDATE_SETTINGS
    payload: Settings[]
}

interface SetCashFunds {
    type: ActionType.SET_CASH_FUNDS
    payload: CashFund[]
}

interface UpdateCashFunds {
    type: ActionType.UPDATE_CASH_FUNDS
    payload: CashFund[]
}

interface RemoveCashFunds {
    type: ActionType.REMOVE_CASH_FUNDS
    payload: string[]
}

interface UpdateChecks {
    type: ActionType.UPDATE_CHECKS
    payload: Check[]
}

interface RemoveChecks {
    type: ActionType.REMOVE_CHECKS
    payload: string[]
}

interface SetCreditCards {
    type: ActionType.SET_CREDIT_CARDS
    payload: CreditCard[]
}

interface UpdateCreditCards {
    type: ActionType.UPDATE_CREDIT_CARDS
    payload: CreditCard[]
}

interface RemoveCreditCards {
    type: ActionType.REMOVE_CREDIT_CARDS
    payload: string[]
}

interface UpdateCreditPayments {
    type: ActionType.UPDATE_CREDIT_PAYMENTS
    payload: CreditPayment[]
}

interface RemoveCreditPayments {
    type: ActionType.REMOVE_CREDIT_PAYMENTS
    payload: string[]
}

interface UpdateFiscalDocuments {
    type: ActionType.UPDATE_FISCAL_DOCUMENTS
    payload: FiscalDocument[]
}

interface RemoveFiscalDocuments {
    type: ActionType.REMOVE_FISCAL_DOCUMENTS
    payload: string[]
}

interface UpdateTransactions {
    type: ActionType.UPDATE_TRANSACTIONS
    payload: Transaction[]
}

interface RemoveTransactions {
    type: ActionType.REMOVE_TRANSACTIONS
    payload: string[]
}

interface SetPaymentTypes {
    type: ActionType.SET_PAYMENT_TYPES
    payload: PaymentType[]
}

interface UpdatePaymentTypes {
    type: ActionType.UPDATE_PAYMENT_TYPES
    payload: PaymentType[]
}

interface RemovePaymentTypes {
    type: ActionType.REMOVE_PAYMENT_TYPES
    payload: string[]
}

interface SetEmployees {
    type: ActionType.SET_EMPLOYEES
    payload: Employee[]
}

interface UpdateEmployees {
    type: ActionType.UPDATE_EMPLOYEES
    payload: Employee[]
}

interface RemoveEmployees {
    type: ActionType.REMOVE_EMPLOYEES
    payload: string[]
}

interface SetExpenseTypes {
    type: ActionType.SET_EXPENSE_TYPES
    payload: ExpenseType[]
}

interface UpdateExpenseTypes {
    type: ActionType.UPDATE_EXPENSE_TYPES
    payload: ExpenseType[]
}

interface RemoveExpenseTypes {
    type: ActionType.REMOVE_EXPENSE_TYPES
    payload: string[]
}

interface UpdateExpenses {
    type: ActionType.UPDATE_EXPENSES
    payload: Expense[]
}

interface RemoveExpenses {
    type: ActionType.REMOVE_EXPENSES
    payload: string[]
}

interface UpdatePaymentOrders {
    type: ActionType.UPDATE_PAYMENT_ORDERS
    payload: PaymentOrder[]
}

interface RemovePaymentOrders {
    type: ActionType.REMOVE_PAYMENT_ORDERS
    payload: string[]
}

interface UpdateAdjustmentNotes {
    type: ActionType.UPDATE_ADJUSTMENT_NOTES
    payload: AdjustmentNote[]
}

interface RemoveAdjustmentNotes {
    type: ActionType.REMOVE_ADJUSTMENT_NOTES
    payload: string[]
}

interface UpdateTickets {
    type: ActionType.UPDATE_TICKETS
    payload: Ticket[]
}

interface RemoveTickets {
    type: ActionType.REMOVE_TICKETS
    payload: string[]
}

interface SelectTickets {
    type: ActionType.SELECT_TICKETS
    payload: Ticket[]
}

export type AdministrationAction =
    SetCurrentEmployee |
    SetSettings |
    SetCashFunds |
    SetCreditCards |
    SetPaymentTypes |
    SetEmployees |
    SetExpenseTypes |
    SetTaxes |
    AdministrationUpdateAction |
    AdministrationRemoveAction |
    SelectTickets

export type AdministrationUpdateAction =
    UpdateTaxes |    
    UpdateSettings |
    UpdateCashFunds |
    UpdateChecks |
    UpdateCreditCards |
    UpdateCreditPayments |
    UpdateFiscalDocuments |
    UpdateTransactions |
    UpdatePaymentTypes |
    UpdateEmployees |
    UpdateExpenseTypes |
    UpdateExpenses |
    UpdatePaymentOrders |
    UpdateAdjustmentNotes |
    UpdateTickets

export type AdministrationRemoveAction =
    RemoveTaxes |    
    RemoveCashFunds |
    RemoveChecks |
    RemoveCreditCards |
    RemoveCreditPayments |
    RemoveFiscalDocuments |
    RemoveTransactions |
    RemovePaymentTypes |
    RemoveEmployees |
    RemoveExpenseTypes |
    RemoveExpenses |
    RemovePaymentOrders |
    RemoveAdjustmentNotes |
    RemoveTickets
